import { render, staticRenderFns } from "./PopularTable.vue?vue&type=template&id=56649f46&scoped=true"
import script from "./PopularTable.vue?vue&type=script&lang=js"
export * from "./PopularTable.vue?vue&type=script&lang=js"
import style0 from "./PopularTable.vue?vue&type=style&index=0&id=56649f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56649f46",
  null
  
)

export default component.exports